import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import NotFound from "../../components/NotFound";

// import CreatePDF from "./pages/CreatePDF";
import Dashboard from "./pages/Dashboard";

const routes = [
  // {
  //   path: "document/new/*",
  //   element: CreatePDF,
  //   permissions: ['CREATE_DOCUMENT', 'READ_DOCUMENT']
  // },
  // {
  //   path: "document/:id/*",
  //   element: CreatePDF,
  //   permissions: ['CREATE_DOCUMENT', 'READ_DOCUMENT']
  // },
  {
    path: "/401",
    element: NotFound,
  },
  {
    path: "*",
    element: Dashboard,
    permissions: ["CREATE_DOCUMENT", "READ_DOCUMENT"],
  },
];

const PDFGenerator = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("pdf-generator")}
      beforeCapture={scope => {
        scope.setTag("module", "pdf-generator");
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

export default PDFGenerator;
